<script setup>
  import Tabbar from '@/components/Tabbar.vue'
  import NavigationLayout from '@/views/NavigationLayout.vue'
  import EstablishmentsPromotions from '@/views/EstablishmentsPromotions.vue'
  import MenuIcon from '@/components/MenuIcon.vue'
  import AdsIcon from '@/components/AdsIcon.vue'
  import Logotype from '@/components/Logotype.vue'

  const tabs = [
    { icon: MenuIcon, component: NavigationLayout },
    { icon: Logotype },
    { icon: AdsIcon, component: EstablishmentsPromotions }
  ]
</script>

<template>
    <Tabbar :tabs="tabs"/>
</template>


